const CMDS = {
  fr: [[/nouveau paragraphe/giu, "\n\n"], [/(retour |nouvelle )?(à|a) la ligne|nouvelle ligne/giu, "\n"], [/point d'interrogation/giu, "?"],
    [/point[- ]virgule/giu, ";"], [/deux[- ]points/giu, ":"], [/(?<![\p{L}])virgule(?![\p{L}])/giu, ","], [/(?<![\p{L}])point(?![\p{L}])/giu, "."]],
  en: [[/new paragraph/gi, "\n\n"], [/new line/gi, "\n"], [/question mark/gi, "?"], [/semicolon/gi, ";"], [/\bcolon\b/gi, ":"],
    [/\bcomma\b/gi, ","], [/full stop|\bperiod\b/gi, "."]],
  de: [[/neuer absatz/giu, "\n\n"], [/neue zeile/giu, "\n"], [/fragezeichen/giu, "?"], [/semikolon/giu, ";"], [/doppelpunkt/giu, ":"],
    [/(?<![\p{L}])komma(?![\p{L}])/giu, ","], [/(?<![\p{L}])punkt(?![\p{L}])/giu, "."]],
  ar: [[/فقرة جديدة/gu, "\n\n"], [/سطر جديد/gu, "\n"], [/علامة استفهام/gu, "؟"], [/فاصلة/gu, "،"], [/نقطة/gu, "."]],
};
const ERASE = { fr: /(?<![\p{L}])(effacer|efface)(?![\p{L}])/iu, en: /\b(delete that|erase|scratch that)\b/i, de: /(?<![\p{L}])(löschen|lösche)(?![\p{L}])/iu, ar: /(احذف|امسح)/u };

export const SPEECH_LANG = { fr: "fr-CA", en: "en-CA", de: "de-DE", ar: "ar-SA" };

export function parseUtterance(raw, lang) {
  const l = CMDS[lang] ? lang : "fr";
  let s = raw.trim();
  if (ERASE[l].test(s)) return { erase: true };
  for (const [re, rep] of CMDS[l]) s = s.replace(re, rep);
  s = s.replace(/[ \t]+([.,;:?!،؟])/g, "$1")
    .replace(/([.,;:?!،؟])[ \t]*[.,;:?!،؟]+/g, "$1")
    .replace(/[ \t]*\n[ \t]*/g, "\n")
    .replace(/^[.,;:]\s*(?=\n)/, "");
  return { text: s };
}

export function joinText(prev, piece) {
  if (!piece) return prev;
  let p = piece;
  const end = prev.trimEnd();
  if (!end || /[.?!؟]$/.test(end) || prev.endsWith("\n")) p = p.replace(/^(\s*)(\p{L})/u, (m, sp, c) => sp + c.toUpperCase());
  if (!prev || /\s$/.test(prev) || /^[\n.,;:?!،؟]/.test(p)) return prev + p;
  return `${prev} ${p}`;
}
